export { default as YoutubePlayer } from './YoutubePlayer';
